(function () {
  const SELECTOR = '[data-blaster-free-shipping]';
  const ROOT = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  const CART_ENDPOINTS = ['/cart/add', '/cart/change', '/cart/update', '/cart/clear'];
  let fetchPromise = null;

  function formatMoney(cents) {
    return new Intl.NumberFormat('es-MX', {
      style: 'currency',
      currency: 'MXN',
      minimumFractionDigits: 0,
      maximumFractionDigits: 0
    }).format((Number(cents) || 0) / 100);
  }

  function getBlocks() {
    return Array.from(document.querySelectorAll(SELECTOR));
  }

  function renderBlock(block, currentAmount) {
    const threshold = Number(block.dataset.threshold || 59900);
    const amount = Math.max(0, Number(currentAmount) || 0);
    const remaining = Math.max(0, threshold - amount);
    const progress = threshold > 0 ? Math.min(100, Math.round((amount / threshold) * 100)) : 0;
    const messageNode = block.querySelector('[data-blaster-message]');
    const pillNode = block.querySelector('[data-blaster-pill]');

    let message = '🚚 Envío GRATIS sobre $599 MXN';

    if (amount > 0 && remaining > 0) {
      message = `Te faltan ${formatMoney(remaining)} MXN para desbloquear envío gratis 🚚`;
    } else if (amount >= threshold) {
      message = '🎉 ¡Ya tienes envío gratis!';
    }

    block.dataset.currentAmount = String(amount);
    block.style.setProperty('--blaster-progress', progress + '%');
    block.classList.toggle('is-unlocked', amount >= threshold);

    if (messageNode) {
      messageNode.textContent = message;
    }

    if (pillNode) {
      pillNode.textContent = progress + '%';
    }
  }

  function renderAll(currentAmount) {
    getBlocks().forEach((block) => renderBlock(block, currentAmount));
  }

  async function fetchCart() {
    if (!fetchPromise) {
      fetchPromise = fetch(ROOT + 'cart.js', {
        headers: { Accept: 'application/json' },
        credentials: 'same-origin'
      })
        .then((response) => {
          if (!response.ok) {
            throw new Error('No se pudo cargar cart.js');
          }

          return response.json();
        })
        .finally(() => {
          fetchPromise = null;
        });
    }

    return fetchPromise;
  }

  async function refreshFromCart() {
    try {
      const cart = await fetchCart();
      renderAll(cart.total_price || 0);
    } catch (error) {
      console.error('[blaster-free-shipping]', error);
    }
  }

  function scheduleRefresh() {
    window.setTimeout(refreshFromCart, 180);
  }

  function interceptFetch() {
    if (window.__blasterFreeShippingFetchIntercepted) {
      return;
    }

    window.__blasterFreeShippingFetchIntercepted = true;
    const originalFetch = window.fetch;

    window.fetch = async function () {
      const response = await originalFetch.apply(this, arguments);
      const requestUrl = String(arguments[0] || '');

      if (CART_ENDPOINTS.some((endpoint) => requestUrl.indexOf(endpoint) !== -1)) {
        scheduleRefresh();
      }

      return response;
    };
  }

  function bindEvents() {
    document.addEventListener('cart:refresh', refreshFromCart);
    document.addEventListener('cart:updated', refreshFromCart);
    document.addEventListener('product:added', scheduleRefresh);
  }

  function init() {
    if (!getBlocks().length) {
      return;
    }

    getBlocks().forEach((block) => {
      renderBlock(block, Number(block.dataset.currentAmount || 0));
    });

    interceptFetch();
    bindEvents();
    refreshFromCart();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init, { once: true });
  } else {
    init();
  }
})();
